import { getDashboardData } from 'modules/society/actions/dashBoardActions';

export const getBeneficiariesViewData = async (societyId, dispatch) => {
  const beneficiariesData = await dispatch(
    getDashboardData(societyId, 'beneficiaries')
  );
  return beneficiariesData;
};
